import React from 'react';
import { PortfolioCase as PortfolioCaseType } from '../../data/portfolioCases';


interface PortfolioCaseProps {
  caseData: PortfolioCaseType;
  onClick: (caseId: string) => void;
}

const PortfolioCaseComponent: React.FC<PortfolioCaseProps> = ({ caseData, onClick }) => {
  const handleClick = () => {
    onClick(caseData.id);
  };

  return (
    <div className="portfolio-case-container" onClick={handleClick}>
      <div 
        className="portfolio-case-background" 
        style={{ backgroundImage: `url('${caseData.image}')` }}
      />
      <div className="portfolio-case-text-wrapper">
        <h4>{caseData.company}</h4>
        <h2>{caseData.title}</h2>
        <p>{caseData.description}</p>
        <button className="view-case-button">
          {caseData.cta}
        </button>
      </div>
    </div>
  );
};

export default PortfolioCaseComponent;